import axios from 'axios';

import UserAgent from '../helpers/userAgent';

const axiosInstanceWithoutInterceptors = axios.create();

function generateAnchorElementFromBlob(
  fileBlob: Blob,
  fileName: string,
  deviceType: string,
  browser: string,
  contentType: string,
) {
  const blob = new Blob([fileBlob], { type: contentType });
  const downloadUrl = window.URL.createObjectURL(blob);

  if ((deviceType === 'tablet' || deviceType === 'mobile') && (browser === 'safari' || browser === 'mobilesafari')) {
    document.location.replace(downloadUrl);
  } else {
    const e = document.createElement('a');
    e.setAttribute('download', fileName);
    e.setAttribute('href', downloadUrl);
    e.setAttribute('target', '_blank');
    document.body.appendChild(e);
    e.click();

    setTimeout(() => {
      document.body.removeChild(e);
      window.URL.revokeObjectURL(downloadUrl);
    }, 1000);
  }
}

export default {
  download: async (url: string, fileName = 'download.csv') => {
    await axios.post(`${window.env.REACT_APP_SINE_ID_API_URI}/ota/cookie`, {}, { withCredentials: true });

    const userAgent = new UserAgent();
    const deviceType = userAgent.getDeviceType();
    const browser = userAgent.getBrowserName();

    const response = await axios.get(url, {
      responseType: 'blob',
    });

    generateAnchorElementFromBlob(response.data, fileName, deviceType, browser, response.headers['content-type']);

    return url;
  },
  downloadAWS: async (url: string, fileName = 'download.csv') => {
    await axios.post(`${window.env.REACT_APP_SINE_ID_API_URI}/ota/cookie`, {}, { withCredentials: true });

    const userAgent = new UserAgent();
    const deviceType = userAgent.getDeviceType();
    const browser = userAgent.getBrowserName();

    // We're calling this endpoint to get the file URL from AWS
    // needs to be obtained with axios for the team switcher to add the necessary headers
    // which is not possible with an anchor element
    const response = await axios.get(url);

    const s3Response = await axiosInstanceWithoutInterceptors.get(response.data.fileUrl, {
      responseType: 'blob',
      withCredentials: false,
      headers: {}, // Ensure no authentication headers are sent to AWS
    });

    generateAnchorElementFromBlob(s3Response.data, fileName, deviceType, browser, s3Response.headers['content-type']);

    return url;
  },
};
